import { render, staticRenderFns } from "./CardResultsPage.vue?vue&type=template&id=36205c16&"
import script from "./CardResultsPage.vue?vue&type=script&lang=js&"
export * from "./CardResultsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36205c16')) {
      api.createRecord('36205c16', component.options)
    } else {
      api.reload('36205c16', component.options)
    }
    module.hot.accept("./CardResultsPage.vue?vue&type=template&id=36205c16&", function () {
      api.rerender('36205c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardResultsPage.vue"
export default component.exports